<template>
    <div class="item">
        <div class="top">
            <p>{{item.name}}</p>
            <span>￥{{item.bonus}}</span>
        </div>
        <p>{{item.user_name+' '+item.user_mobile}}</p>
        <div class="bottom">
            <p>{{item.create_time}}</p>
            <span>{{item.order_commission_status}}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "incomeItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
    created() {

    },
};
</script>
<style lang="less" scoped>
.item {
    padding: 10px;
    border-bottom: 1px dashed #e1e1e1;
    
    .top {
        display: flex;
        font-weight: 600;
        align-items: center;

        > p {
            flex: 1;
            color: #333;
            font-size: 1.4rem;
        }

        > span {
            color: #EF1400;
            font-size: 1.4rem;
        }
    }

    > p {
        color: #333;
        line-height: 2;
        font-size: 1.3rem;
    }

    .bottom {
        display: flex;
        align-items: center;

        p {
            flex: 1;
            color: #999;
            font-size: 1.3rem;
        }

        span {
            color: #7181EB;
            font-size: 1.3rem;
        }
    }
}
</style>